import React, { useState } from "react";
import Sidebar from "../components/admin/Sidebar";
import Dashboard from "../components/admin/Dashboard";
import CreateUser from "../components/admin/CreatUser";
import AllUsers from "../components/admin/AllUsers";
import AllKarnets from "../components/admin/AllKarnets";
import AllPayments from "../components/admin/AllPayments";
import AdminCalendar from "../components/admin/AdminCalendar";
import AllTrenerzy from "../components/admin/AllTrenerzy";

const AdminPanel = () => {
  const [activeComponent, setActiveComponent] = useState("Dashboard");

  // Function to render the selected component
  const renderComponent = () => {
    switch (activeComponent) {
      case "Dashboard":
        return <Dashboard />;
      case "CreateUsers":
        return <CreateUser />;
      case "AllUsers":
        return <AllUsers />;
      case "AllKarnets":
        return <AllKarnets />;
      case "AllPayments":
        return <AllPayments />;
      case "Kalendarz":
        return <AdminCalendar />;
      case "AllTrenerzy":
        return <AllTrenerzy />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar setActiveComponent={setActiveComponent} />

      {/* Main content area */}
      <div className="flex-1 p-5 bg-gray-100">{renderComponent()}</div>
    </div>
  );
};

export default AdminPanel;
